import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";
import {
  LOGIN,
  LOGINOTP,
  LOGINPHONENUMBER,
  LOGOUT,
  REGISTER,
  CHECK_AUTH,
  UPDATE_USER,
  CLEAR_ERROR,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  GET_EMAIL_CODE_INVIT,
  RESEND_VERIFICATION_EMAIL,
  RESEND_OTP_CODE,
  FA_QRCODE
} from "./actions.type";
import { SET_AUTH, PURGE_AUTH, SET_ERROR, PURGE_ERROR,RESET_STATE,VERIFY_USER } from "./mutations.type";
import router from '@/router';
const state = {
  errors: null,
  user: {},
  isAuthenticated: !!JwtService.getToken(),
  verify:false
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  verify(state){
    return state.verify;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise(resolve => {
      ApiService.post("/candidates/login", credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data.data);

          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.meta.errors[0]);
        });
    });
  },
  [LOGINOTP](context, credentials) {
    return new Promise(resolve => {
      ApiService.post("/candidates/loginotp", credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data.data);

          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.meta.errors[0]);
        });
    });
  },
  [FA_QRCODE](context) {
    return new Promise(resolve => {
      ApiService.get("/api/fa/qrcode")
        .then(({ data }) => {
          context.commit(SET_AUTH, data.data);

          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.meta.errors[0]);
        });
    });
  },
  [LOGINPHONENUMBER](context, credentials) {
    return new Promise(resolve => {
      ApiService.post("/candidates/loginphonenumber", credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data.data);

          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.meta.errors[0]);
        });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [REGISTER](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post("/candidates/register", credentials)
        .then(({ data }) => {
          //context.commit(SET_AUTH, data.data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.meta.errors);
          reject(response);
        });
    });
  },
  [GET_EMAIL_CODE_INVIT](context,codeinvit) {
    return new Promise((resolve, reject) => {
      ApiService.post("/candidates/register/verify_email",{codeinvit:codeinvit})
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.meta.errors);
          reject(response);
        });
    });
  },
  async [CHECK_AUTH](context) {
    let userRole = null
    if (JwtService.getToken()) {
      ApiService.setHeader();
      await ApiService.post("/candidates/me")
        .then(({ data }) => {
          data.data.token = JwtService.getToken();
          context.commit(SET_AUTH, data.data);
          userRole = data.data.user.role
        })
        .catch(err => {
          context.commit(PURGE_AUTH);
          context.commit(RESET_STATE);
          router.push({ name: "login" })
        });
    } else {
      context.commit(PURGE_AUTH);
      context.commit(RESET_STATE);
      router.push({ name: "login" })
    }
    return userRole;
  },
  [UPDATE_USER](context, payload) {
    const { email, username, password } = payload;
    const user = {
      email,
      username
    };
    if (password) {
      user.password = password;
    }

    return ApiService.put("/candidates/user", user).then(({ data }) => {
      context.commit(SET_AUTH, data.user);
      return data;
    });
  },
  [FORGOT_PASSWORD](context, email) {
    return new Promise((resolve, reject) => {
      ApiService.post("/candidates/reset_password_token", email)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.meta.errors);
          reject(response);
        });
    });
  },
  [RESET_PASSWORD](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("/candidates/reset_password", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.meta.errors);
          reject(response);
        });
    });
  },
  [CLEAR_ERROR](context) {
    context.commit(PURGE_ERROR);
  },
  [RESEND_VERIFICATION_EMAIL](context, email) {
    return new Promise((resolve, reject) => {
      ApiService.post("/candidates/resend_verification_email", email)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.meta.errors);
          reject(response);
        });
    });
  },
  [RESEND_OTP_CODE](context, email) {
    return new Promise((resolve, reject) => {
      ApiService.post("candidates/resend_otp_code", email)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.meta.errors);
          reject(response);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [PURGE_ERROR](state) {
    state.errors = null;
  },
  [SET_AUTH](state, data) {
    state.isAuthenticated = true;
    state.user = data.user;
    state.errors = null;
    JwtService.saveToken(data.token);
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = null;
    JwtService.destroyToken();
  },
  [VERIFY_USER](state,verify){
    state.verify=verify;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
